import styled from 'styled-components'

interface LOADER_STYLED_PROPS {
  duration: number | 5.5
}
export const White = styled.div`
  position: absolute;
  top: calc(50% - 55px);
  background-repeat: no-repeat;
  width: 293px;
  height: 108px;
  z-index: 2313;
`

export const Blue = styled.div<LOADER_STYLED_PROPS>`
  position: absolute;
  top: calc(50% - 55px);
  background-repeat: no-repeat;
  width: 293px;
  height: 108px;
  background-color: #050423;
  z-index: 2313;
  overflow: hidden;
  animation: whidthGrow linear;
  animation-duration: ${({ duration }) => (duration ? duration + 's' : '5.5s')};
  @keyframes whidthGrow {
    0% {
      width: 0;
    }
    100% {
      width: 293px;
    }
  }
`
export const Loader = styled.div`
  width: 293px;
  height: 108px;
`
